import script from "./CompanyWriter.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyWriter.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyWriter.vue?vue&type=style&index=0&id=3f3aafcf&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f3aafcf"]])

export default __exports__